<template>
  <div id="app" :style="vhProperty">
    <transition name="modal-fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
// import Player from '@vimeo/player';
import Keycloak from 'keycloak-js';
import { Base64 } from 'js-base64';
import { KEYCLOCK_URL, KEYCLOCK_REALM_NAME, KEYCLOCK_CLIENT_ID, APP_ID } from './config';
import axios from 'axios';
export default {
  name: 'engine',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Default Title',
    // all titles will be injected into this template
    titleTemplate: '%s | My Awesome Webapp',
  },
  data() {
    return {
      vh: 0,
    };
  },
  created() {
    this.initVimeo();
    this.onResize();
  },
  mounted() {
    if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'app') {
      this.login();
    }
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.vh = window.innerHeight / 100;
    },

    initVimeo() {
      let Vimeo = require('vimeo').Vimeo;
      let client = new Vimeo(
        'b05780f636d164c28c12bc9cc3f30170fa1e4b6c',
        'XR6Cr9lm+L2FI2Vgi86vKg3NQk+CLQ//TGVsuszDSgfCrpTsFUjcNm3SOHnfhZ12bo/vP02Aek/lPIHAQdYQHO+hv82J6eTiBmrCLL2SmPHuLCCpHvEx6iQtDGsqNbQy',
        '926446fc6f9964637c5bbbe7dc776b02'
      );

      client.request(
        {
          method: 'GET',
          path: '/me/projects',
        },
        (error, body, status_code, headers) => {
          if (error) {
            console.log(error);
            if (('' + error).includes('Failed to fetch')) this.$store.commit('SET_VIDEO_STATUS_CODE', 503);
          }
          if (status_code == 401) this.$store.commit('SET_VIDEO_STATUS_CODE', 401);
          if (status_code == 200) {
            if (body.data.findIndex((i) => i.name == 'chemia_8')) {
              let projects = body.data[body.data.findIndex((i) => i.name == this.$store.getters.multibookType)];
              if (projects) {
                client.request(
                  {
                    method: 'GET',
                    path: projects.uri + '/videos',
                    query: {
                      per_page: 99,
                    },
                  },
                  (error, body, status_code, headers) => {
                    this.$store.commit('SET_VIDEO_STATUS_CODE', status_code);
                    if (error) {
                      console.log(error);
                    }
                    if (body.data) {
                      this.videoList = body.data;
                      this.$store.commit('SET_VIDEO_DATA', body.data);
                    }
                  }
                );
              } else {
                //folder not found
                this.$store.commit('SET_VIDEO_STATUS_CODE', 401);
              }
            }
          }
        }
      );
    },
    login() {
      var keycloak = Keycloak({
        realm: `${KEYCLOCK_REALM_NAME}`,
        url: `${KEYCLOCK_URL}`,
        clientId: `${KEYCLOCK_CLIENT_ID}`,
        'ssl-required': 'all',
        resource: `${KEYCLOCK_CLIENT_ID}`,
        'public-client': true,
        'confidential-port': 0,
      });

      keycloak
        .init({
          // flow: 'implicit',
          promiseType: 'native',
          onLoad: 'login-required',
        })
        .then((authenticated) => {
          this.setCookie('logged_external_app', true);
          let decodedToken = this.decodeToken(keycloak.token);
          let redaktor = decodedToken.realm_access.roles.includes('ROLE_MULTIMEDIA_EDITOR');
          if (process.env.VUE_APP_MATERIAL_ID) this.request(keycloak.token, redaktor, keycloak.idToken);
          return authenticated;
        })
        .catch((error) => {
          console.error(error);
        });

      keycloak.onTokenExpired = () => {
        keycloak
          .updateToken(30)
          .then((refreshed) => {
            if (refreshed) {
              this.setCookie('logged_external_app', true);
              this.$store.commit('TOKEN_SET', keycloak.token);
            } else {
              console.log('Token is still valid');
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };
      keycloak.onAuthLogout = () => {
        this.removeCookie('logged_external_app', true);
      };
    },

    setCookie(cname, cvalue) {
      const expires = 300;
      document.cookie = cname + '=' + cvalue + ';' + 'Max-Age=' + expires + ';Domain=.mac.pl;path=/';
    },
    removeCookie(cname, cvalue) {
      const expires = 0;

      document.cookie = cname + '=' + cvalue + ';' + 'Max-Age=' + expires + ';Domain=.mac.pl;path=/';
    },

    request(token, redaktor, idToken) {
      let data = { authorization: `Bearer ${token}` };
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://multibooki-api.app.mac.pl/api/profile',
        headers: {
          'Content-Type': 'application/json',
          id: process.env.VUE_APP_MATERIAL_ID,
        },
        data: data,
      };
      if (config) {
        axios(config)
          .then((response) => {
            if (!response.data.access && !redaktor) {
              this.$store.commit('SET_MATERIAL_ACCESS', 'false');
              this.$router.push({ name: 'error', params: { idToken: idToken } });
            } else {
              this.$store.commit('SET_MATERIAL_ACCESS', 'true');
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    decodeToken(data) {
      let encodedArray = data.split('.');
      return JSON.parse(Base64.decode(encodedArray[1]));
    },
    changeColor() {
      console.log('click');
      return this.inc();
    },
    inc() {
      return this.counter++;
    },
  },
  computed: {
    vhProperty() {
      return { '--vh': `${this.vh}px` };
    },
  },
};
</script>

<style lang="sass" scoped>
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
</style>
